export var ACTIVAR = 'PERSIANA_ACTIVAR';
export var activar = function activar() {
  return {
    type: ACTIVAR
  };
};
export var DESACTIVAR = 'PERSIANA_DESACTIVAR';
export var desactivar = function desactivar() {
  return {
    type: DESACTIVAR
  };
};
export var MOSTRAR = 'PERSIANA_MOSTRAR';
export var mostrar = function mostrar() {
  return {
    type: MOSTRAR
  };
};
export var OCULTAR = 'PERSIANA_OCULTAR';
export var ocultar = function ocultar() {
  return {
    type: OCULTAR
  };
};
export var RESETEAR = 'PERSIANA_RESETEAR';
export var resetear = function resetear() {
  return {
    type: RESETEAR
  };
};
export var POSICION = 'PERSIANA_POSICION';
export var posicion = function posicion(_posicion) {
  return {
    type: POSICION,
    posicion: _posicion
  };
};